import * as tslib_1 from "tslib";
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
/**
 * A function which returns properties that decide whether to show certain category actions
 * includes a collection of common categories for the given rows, and whether any of the row has categories
 * @param tableView to which the rows belong
 * @param rowKeys of the rows for which to get the intersection of categories
 * @returns properties that decide whether to show certain category actions
 */
export default function getCategoryActionDecisionProperties(tableView, rowKeys) {
    var commonCategoriesToReturn = [];
    var rowCategoryMap = {};
    var rowsAllCategories = [];
    // Get all categories for all rows in rowsAllCategories collection
    for (var i = 0; i < rowKeys.length; i++) {
        var rowCategories = MailRowDataPropertyGetter.getCategories(rowKeys[i], tableView) || [];
        rowsAllCategories.push.apply(rowsAllCategories, tslib_1.__spread(rowCategories));
    }
    // Build a category name <=> count map for the categories in rowsAllCategories collection
    for (var i = 0; i < rowsAllCategories.length; i++) {
        var categoryName = rowsAllCategories[i];
        if (!rowCategoryMap[categoryName]) {
            rowCategoryMap[categoryName] = 1;
        }
        else {
            rowCategoryMap[categoryName] = rowCategoryMap[categoryName] + 1;
        }
    }
    // Iterate map to get the categories for which the count is same as the rowKeys count,
    // which means the category appeared in all rows
    Object.keys(rowCategoryMap).forEach(function (key) {
        var categoryCount = rowCategoryMap[key];
        if (categoryCount == rowKeys.length) {
            commonCategoriesToReturn.push(key);
        }
    });
    return {
        commonRowCategories: commonCategoriesToReturn,
        rowsHaveCategories: rowsAllCategories.length > 0,
    };
}
//# sourceMappingURL=getCategoryActionDecisionProperties.js.map